import axios from 'axios';
import withUrl from '../utils/url/withUrl';

export default {
  appealCredits: () => axios.post(withUrl('support/credit/appeals')),
};
